window.onload = function () {
    const today = new Date();
    // テスト用　月は-1した数字を入力する
    // const today = new Date(2024, 10, 29);
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();
    let resultArray = setDate(currentYear, currentMonth, currentDay);

    if(currentDay > resultArray['untilDay']) {
        if(currentMonth === 12) {
            resultArray = setDate(currentYear + 1, 1, 1);
        } else {
            resultArray = setDate(currentYear, currentMonth + 1, 1);
        }
    }

    const textArea = document.getElementsByClassName('coupon__date');
    const fromMonth = document.getElementsByClassName('fromMonth');
    const fromDay = document.getElementsByClassName('fromDay');
    const fromWeek = document.getElementsByClassName('fromWeek');
    const untilMonth = document.getElementsByClassName('untilMonth');
    const untilDay = document.getElementsByClassName('untilDay');
    const untilWeek = document.getElementsByClassName('untilWeek');
    
    for(i=0; i<textArea.length; i++) {
        fromMonth[i].textContent = resultArray['fromMonth'];
        fromDay[i].textContent = resultArray['fromDay'];
        fromWeek[i].textContent = resultArray['fromWeek'];
        untilMonth[i].textContent = resultArray['untilMonth'];
        untilDay[i].textContent = resultArray['untilDay'];
        untilWeek[i].textContent = resultArray['untilWeek'];
        textArea[i].style.visibility = 'visible';
    }

    function setDate(setYear, setMonth, setDay) {        
        const longMonth = [1, 3, 5, 7, 8, 10, 12];
        const shortMonth = [4, 6, 9, 11];

        //例外の月はここに記入
        const exceptionMonthGroup = [
            {
                month: 1,
                fromDay: 4,
                untilDay: 31
            },
            {
                month: 12,
                fromDay: 1,
                untilDay: 28
            }
        ];

        let fromMonth = "";
        let untilMonth = "";
        let fromDay = "";
        let fromWeek = "";
        let untilDay = "";
        let untilWeek = "";

        const exMonth = exceptionMonthGroup.find(({month}) => month == setMonth);

        if(exMonth){
            fromMonth = setMonth;
            untilMonth = setMonth;
            if(setDay <= 15) {
                fromDay = exMonth['fromDay'];
                untilDay = exMonth['untilDay'];
                if(untilDay > 15) {
                    untilDay = 15;
                }
            } else if(setDay > 15) {
                fromDay = exMonth['fromDay'];
                if(fromDay < 15) {
                    fromDay = 15;
                }
                untilDay = exMonth['untilDay'];
            }
            fromWeek = getWeek(setYear, fromMonth, fromDay);
            untilWeek = getWeek(setYear, untilMonth, untilDay);
        } else {
            if(setDay <= 15) {
                fromMonth = setMonth;
                fromDay = 1;
                fromWeek = getWeek(setYear, fromMonth, fromDay);
                untilMonth = setMonth;
                untilDay = 15;
                untilWeek = getWeek(setYear, untilMonth, untilDay);
            } else if(setDay > 15) {
                fromMonth = setMonth;
                fromDay = 15;
                fromWeek = getWeek(setYear, fromMonth, fromDay);
                untilMonth = setMonth;
                if(longMonth.includes(setMonth)){
                    untilDay = 31;
                } else if(shortMonth.includes(setMonth)){
                    untilDay = 30;
                } else if(setMonth == 2){
                    if(setYear % 4 == 0) {
                        untilDay = 29;
                    } else {                                    
                        untilDay = 28;
                    }
                }
                untilWeek = getWeek(setYear, untilMonth, untilDay);
            }
        }

        const resultArray = {
            fromMonth: fromMonth,
            fromDay: fromDay,
            fromWeek: fromWeek,
            untilMonth: untilMonth,
            untilDay: untilDay,
            untilWeek: untilWeek
        };
        return resultArray;
    }

    function getWeek(setYear, setMonth, setDay) {        
        const weekJp = ['日', '月', '火', '水', '木', '金', '土'];
        const date = new Date(setYear, setMonth - 1, setDay);
        return weekJp[date.getDay()];
    }
  }